// Set only by production builds, so dev, stage and preview tokens never reach
// the production docs service. Point it at another docs deployment to test there.
const DOCS_URL = import.meta.env.VITE_DOCS_URL as string | undefined;
export const DOCS_ORIGIN: string | null = DOCS_URL
  ? new URL(DOCS_URL).origin
  : null;

export interface IDocsAccessRequest {
  state: string;
  returnTo: string;
  createdAt: number;
}

export function validDocsHandoff(value: unknown): value is string {
  if (!DOCS_ORIGIN || typeof value !== 'string') return false;
  try {
    const url = new URL(value);
    return (
      url.origin === DOCS_ORIGIN &&
      url.pathname === '/auth/redeem' &&
      !url.username &&
      !url.password &&
      !url.hash &&
      /^[A-Za-z0-9_-]{43}$/.test(url.searchParams.get('code') || '')
    );
  } catch {
    return false;
  }
}
